import { callConfigFunction } from './callConfigFunction';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function callEventFunction(props, eventName, argumentNames, ...argumentValues) {
    var _a;
    callConfigFunction((_a = props.config.event) === null || _a === void 0 ? void 0 : _a[eventName], 'event ' + eventName, argumentNames, ...argumentValues);
}
